/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Spaces_Tools_Badge_CountInputs */



/**
* | output |
* | --- |
* | "{count} tool calls available in chat" |
*
* @param {Spaces_Tools_Badge_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_tools_badge_count = /** @type {((inputs: Spaces_Tools_Badge_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Tools_Badge_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Tool-Aufrufe im Chat verfügbar`)
	return /** @type {LocalizedString} */ (`${i?.count} tool calls available in chat`)
});